// @flow

import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import styled from "styled-components";
import { Overlay, OverlayTrigger, Popover } from "react-bootstrap";

const Arrow = styled.div`
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 11px;

  &:after {
    content: "";
    border-color: transparent;
    border-width: 10px;
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }

  ${({ placement = "top", backgroundColor = "white", borderColor = "#999" }) => {
    let opposite;
    switch (placement) {
      case "top":
        opposite = "bottom";
        break;
      case "bottom":
        opposite = "top";
        break;
      case "left":
        opposite = "right";
        break;
      case "right":
        opposite = "left";
        break;
      default:
        opposite = "bottom";
    }

    let centerAnchor;
    if (placement === "top" || placement === "bottom") {
      centerAnchor = "left";
    } else if (placement === "left" || placement === "right") {
      centerAnchor = "top";
    }

    return `
      ${opposite}: -11px;
      ${centerAnchor}: 50%;
      margin-${centerAnchor}: -11px;
      border-${placement}-color: ${borderColor};
      border-${opposite}-width: 0;

      &:after {
        margin-${centerAnchor}: -10px;
        ${opposite}: 1px;
        border-${placement}-color: ${backgroundColor};
        border-${opposite}-width: 0;
      }
    `;
  }}

`;
const StyledPopover = styled(({ backgroundColor, borderColor, ...rest }) => (
  <Popover {...rest} />
))`
  ${({ backgroundColor, borderColor }) => {
    let styles = "";
    if (backgroundColor) {
      console.warn(backgroundColor);
      styles += `background-color: ${backgroundColor} !important;`;
    }
    if (borderColor) {
      styles += `border-color: ${borderColor} !important;`;
    }

    return styles;
  }}
`;

const InactiveOverlay = () => <span />;

export default class PopoverOverlay extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired
  };

  constructor(props, context) {
    super(props, context);

    this._mountNode = null;
  }

  componentDidMount() {
    this._mountNode = document.createElement("div");
    this.renderOverlay();
  }

  componentDidUpdate() {
    this.renderOverlay();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
  }

  renderOverlay() {
    ReactDOM.unstable_renderSubtreeIntoContainer(
      this,
      this._overlay,
      this._mountNode
    );
  }

  makeOverlay(overlay, show, placement) {
    return (
      <Overlay show={show} placement={placement} target={this}>
        {overlay}
      </Overlay>
    );
  }

  render() {
    const {
      trigger = ["hover", "focus"],
      backgroundColor,
      borderColor,
      placement = "top",
      tooltipContent,
      active,
      children,
      id
    } = this.props;

    const popover = (
      <StyledPopover
        backgroundColor={backgroundColor}
        borderColor={borderColor}
        id={id}
      >
        {tooltipContent}
        <Arrow
          placement={placement}
          backgroundColor={backgroundColor}
          borderColor={borderColor}
        />
      </StyledPopover>
    );

    this._overlay = this.makeOverlay(
      popover,
      trigger === "controlled" && active,
      placement
    );

    if (trigger === "controlled") {
      return children;
    }

    return (
      <OverlayTrigger
        trigger={trigger}
        placement={placement}
        overlay={active ? popover : <InactiveOverlay />}
      >
        {children}
      </OverlayTrigger>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Popover.js